import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Called when we change the first week of the year, updates the new value in calendar appearance store
 * @firstWeekOfYear: new value for first week of the year
 */
export default mutatorAction('selectFirstWeekOfYearOption', function selectFirstWeekOfYearOption(firstWeekOfYear) {
    var optionState = store();
    optionState.firstWeekOfYear = firstWeekOfYear;
});
//# sourceMappingURL=selectFirstWeekOfYearOption.js.map